import monitoring from '../services/monitoring';
import { DesignStateMultiBoard, isSerializedStandardBoard } from '../types';

type HasAllObjectsRemovedResult = {
  allObjectsRemoved: boolean;
  previousObjectsCount: number;
  artboardCount: number;
  previousArtboardCount: number;
};

export const getStateObjectsCount = (state?: DesignStateMultiBoard): number => {
  if (state?.boards) {
    return state.boards.reduce(
      (count, board) =>
        board.objects?.length ? count + board.objects.length : count,
      0
    );
  } else {
    return 0;
  }
};

export function getHasAllObjectsRemoved(): (
  id: string,
  state?: DesignStateMultiBoard
) => HasAllObjectsRemovedResult {
  const previousState: {
    id: string | undefined;
    objectsCount: number;
    artboardCount: number;
  } = {
    id: undefined,
    objectsCount: -1,
    artboardCount: -1,
  };

  /**
   * Verify if design update removes all objects from all boards (only when more than 1 board) in case there were objects before
   * @param {string} designId design id
   * @param {DesignStateMultiBoard | undefined} state design state
   */
  return function hasAllObjectsRemoved(
    designId: string,
    state?: DesignStateMultiBoard
  ): HasAllObjectsRemovedResult {
    let allObjectsRemoved = false;
    let artboardCount = 0;
    const previousObjectsCount = previousState.objectsCount;
    const previousArtboardCount = previousState.artboardCount;
    try {
      const currentObjectsCount = getStateObjectsCount(state);
      artboardCount =
        state?.boards?.filter(isSerializedStandardBoard).length ?? 0;
      allObjectsRemoved =
        artboardCount > 1 &&
        previousState.id === designId &&
        previousState.objectsCount > 0 &&
        currentObjectsCount === 0;

      previousState.id = designId;
      previousState.objectsCount = currentObjectsCount;
      previousState.artboardCount = artboardCount;
    } catch (error) {
      monitoring.captureException(error, {
        designId: designId,
      });
    }
    return {
      allObjectsRemoved,
      previousObjectsCount,
      artboardCount,
      previousArtboardCount,
    };
  };
}
